import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";

const ConditionLoader = () => {
  return (
    <ContentLoader speed={2} width={500} height={80} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="5" y="5" rx="0" ry="0" width="146" height="80" />
     <rect x="170" y="5" rx="0" ry="0" width="320" height="35" />
     <rect x="170" y="45" rx="0" ry="0" width="320" height="35" />
    </ContentLoader>
  );
};

export default ConditionLoader;

